import React from 'react'
import PropTypes from 'prop-types'

export default function SwiperNavigation({ prevRef, nextRef }) {
  return (
    <div className="adagio-swiper-navigation">
      <button
        ref={prevRef}
        type="button"
        className="slider-svg-arrow slider-svg-arrow_prev swiper-button-prev"
        aria-label="Previous slide"
      >
        <i className="icon icon-slider-arrow-next" aria-hidden="true"></i>
      </button>
      <button
        ref={nextRef}
        type="button"
        className="slider-svg-arrow slider-svg-arrow_next swiper-button-next"
        aria-label="Next slide"
      >
        <i className="icon icon-slider-arrow-next" aria-hidden="true"></i>
      </button>
    </div>
  )
}

SwiperNavigation.propTypes = {
  prevRef: PropTypes.func.isRequired,
  nextRef: PropTypes.func.isRequired,
}
